import { useMemo } from "react";
import useAbacAccess from "./useAbacAccess";

/**
 * Shared User-module ABAC leaf gates (multi-access only; fail-open).
 * Paths match Omni src: canAccess("user", area, leaf).
 */
export default function useUserModuleAbac() {
  const { canAccess, shouldEnforce } = useAbacAccess();

  return useMemo(
    () => ({
      shouldEnforce,

      canViewProfile: canAccess("user", "profile", "view"),
      canCreateProfile: canAccess("user", "profile", "create"),
      canUpdateProfile: canAccess("user", "profile", "update"),
      canDeleteProfile: canAccess("user", "profile", "delete"),

      canViewUser: canAccess("user", "profile", "view"),
      canCreateUser: canAccess("user", "profile", "create"),
      canUpdateUser: canAccess("user", "profile", "update"),
      canDeleteUser: canAccess("user", "profile", "delete"),

      canUpdateFlag: canAccess("user", "flag", "update"),

      canViewConfiguration: canAccess("user", "configuration", "view"),
      // Configuration UI has no Update action for any role (view-only).
      canUpdateConfiguration: false,

      canViewSession: canAccess("user", "session", "view"),

      canUpdateBalance: canAccess("user", "balance", "update"),

      canViewBlockStatus: canAccess("user", "block_status", "view"),

      canViewToken: canAccess("user", "token", "view"),
      canGenerateToken: canAccess("user", "token", "generate"),
      // No separate regenerate leaf in this product — same gate as generate (DU runtime).
      canRegenerateToken: canAccess("user", "token", "generate"),

      canViewTransactionMode: canAccess("user", "transaction_mode", "view"),
      canUpdateTransactionMode: canAccess("user", "transaction_mode", "update"),

      canViewMultiAccess: canAccess("user", "multi_access", "view"),
      canCreateMultiAccess: canAccess("user", "multi_access", "create"),
      canUpdateMultiAccess: canAccess("user", "multi_access", "update"),
      canDeleteMultiAccess: canAccess("user", "multi_access", "delete"),
      canViewMobileEmail: canAccess("user", "multi_access", "view"),

      canViewUserTemplates: canAccess("user", "user_templates", "view"),
      canCreateUserTemplates: canAccess("user", "user_templates", "create"),
      canUpdateUserTemplates: canAccess("user", "user_templates", "update"),
      canDeleteUserTemplates: canAccess("user", "user_templates", "delete"),

      canViewUserLimit: canAccess("user", "limit", "view"),
    }),
    [canAccess, shouldEnforce]
  );
}
